// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: what a nudge card's Connect and try buttons open. In the main window: the Konvo panel.
// In the Rail (no panel there): the Konvo DM in the main window, which then opens the panel
// (RailRouteHandoff calls openNudgeHandoff with the `open` value).

import {Routes} from '@app/app/Routes';
import {
	type NudgePanelRequest,
	nudgeHandoffRoute,
	parseNudgeOpenValue,
} from '@app/features/konvo_engagement/utils/NudgeHandoff';
import KonvoPanel, {type PanelSource} from '@app/features/konvo_panel/state/KonvoPanel';
import {isRailWindow} from '@app/features/konvo_rail/utils/RailWindow';

function openPanel(request: NudgePanelRequest | null, nudgeId?: string, source: PanelSource = 'nudge'): void {
	const tracking = {source, page: 'chats', ...(nudgeId ? {nudgeId} : {})};
	KonvoPanel.open(
		request && !(request.starter === 'free' && !request.request)
			? {...request, ...tracking}
			: {starter: 'free', ...tracking},
	);
}

/** Opens the panel for a nudge card button (`null` = just the connect step). */
export function openNudgePanel(
	request: NudgePanelRequest | null,
	dmChannelId: string | null,
	nudgeId?: string,
	source: PanelSource = 'nudge',
): void {
	if (isRailWindow() && dmChannelId) {
		void Promise.all([import('@app/features/konvo_rail/RailHost'), import('@app/features/konvo_rail/RailRoutes')]).then(
			([host, routes]) =>
				host.openInMainWindow(nudgeHandoffRoute(Routes.dmChannel(dmChannelId), request, routes.RAIL_OPEN_PARAM)),
		);
		return;
	}
	openPanel(request, nudgeId, source);
}

/** The main window's side of a Rail hand-off: `value` is the route's `open` parameter. */
export function openNudgeHandoff(value: string): boolean {
	const request = parseNudgeOpenValue(value);
	if (!request) return false;
	openPanel(request);
	return true;
}
